import { createSlice } from '@reduxjs/toolkit';
import { INITIAL_STEP } from '../../components/gamificationTooltip/constants';

const initialState = {
  show: false,
  data: {
    target: null,
    coordinates: null,
    step: "SELECT_ANY_PROP", //INITIAL_STEP,
    placement: "bottom",
    showArrow: true
  }
};

const gamificationTooltip = createSlice({
  name: 'gamificationTooltip',
  initialState,
  reducers: {
    resetState: (state) => {
      return {
        ...initialState,
      };
    },
    setData: (state, { payload }) => {
      if ("step" in payload) {
        state.data.step = payload.step;
      }
      if ("coordinates" in payload) {
        state.data.coordinates = payload.coordinates;
      }
      if ("target" in payload) {
        state.data.target = payload.target;
      }
      if ("placement" in payload) {
        state.data.placement = payload.placement;
      }
      if ("showArrow" in payload) {
        state.data.showArrow = payload.showArrow;
      }
    },
    resetData: (state) => {
      state = initialState;
    },
    show: (state) => {
      state.show = true;
    },
    hide: (state) => {
      state.show = false;
    },
  },
});

export const gamificationTooltipActions = gamificationTooltip.actions;
export const gamificationTooltipSelector = (state) => state.gamificationTooltip;
export const gamificationTooltipReducer = gamificationTooltip.reducer;
export default gamificationTooltipReducer;

export const selectGamificationTooltipData = (state) => state.gamificationTooltip.data;
export const selectGamificationTooltipShow = (state) => state.gamificationTooltip.show;
